import apiData from './apiData';

const api = apiData();
export { api };
